export default "__VITE_ASSET__CLMWeRbe__"